import { Select as SelectNextUI, SelectItem, SelectProps } from "@heroui/react"
import { baseInputClassName } from "./input"
import { useTranslation } from "react-i18next"

interface Option {
  key?: string
  label?: string
  type?: string
  name?: string
  id?: number
}

interface CustomSelectProps extends Omit<SelectProps, "children"> {
  data: Option[]
}

const Select = ({
  data,
  value,
  classNames,
  ...props
}: CustomSelectProps) => {
  const { t } = useTranslation()
  return (
    <SelectNextUI
      {...props}
      classNames={{
        label: baseInputClassName.label,
        trigger: [
          ...baseInputClassName.inputWrapper,
          "data-[open=true]:border-green-500"
        ],
        value: baseInputClassName.input,
        ...classNames
      }}
      value={value}
      variant="bordered"
      size="lg"
      listboxProps={{
        itemClasses: {
          base: "data-[disabled=true]:hidden"
        }
      }}>
      {data.map(item => (
        <SelectItem key={item.key} value={item.key}>
          {item?.label && t(item.label)}
        </SelectItem>
      ))}
    </SelectNextUI>
  )
}
export default Select
